import { IconMaintenance } from 'central-icons/IconMaintenance';

import { Link, Text } from '@revelio/ui';

import styles from './card-sections.module.css';
import layoutStyles from './skills-section.module.css';

interface SkillsSectionProps {
  skills: string[];
  isExpanded: boolean;
  onToggleExpanded: () => void;
}

export const SkillsSection = ({
  skills,
  isExpanded,
  onToggleExpanded,
}: SkillsSectionProps) => {
  if (!skills.length) return null;

  const displaySkills = isExpanded ? skills : skills.slice(0, 5);

  return (
    <div className={layoutStyles.section}>
      <div className={layoutStyles.sectionIcon}>
        <IconMaintenance size={16} />
      </div>
      <div className={layoutStyles.skillsList}>
        <Text fontSize="sm">{displaySkills.join(', ')}</Text>
        {skills.length > 5 && (
          <Link
            className={styles.moreLink}
            onClick={(e) => {
              e.stopPropagation();
              onToggleExpanded();
            }}
          >
            {isExpanded ? 'Show Less' : 'More'}
          </Link>
        )}
      </div>
    </div>
  );
};
